import { AnalysisPeriodMonths, ZillowHomeValueIndexTrendsData } from '../zillow/types.ts';

export const getHousingTrendsInterval = (
  housingTrendsData: ZillowHomeValueIndexTrendsData | undefined,
): AnalysisPeriodMonths => {
  const firstIndexWithAffectedComps = housingTrendsData?.historical.findIndex(
    (month) => month.affectedComps,
  );
  const monthsFromFirstAffectedCompToPresent =
    (housingTrendsData?.historical.length ?? 0) +
    (housingTrendsData?.projection?.length ?? 0) -
    (firstIndexWithAffectedComps ?? 0);

  return monthsFromFirstAffectedCompToPresent > 12 ? 24 : 12;
};
